import script from "./Start2.vue?vue&type=script&setup=true&lang=js"
export * from "./Start2.vue?vue&type=script&setup=true&lang=js"

import "./Start2.vue?vue&type=style&index=0&id=9c4474a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c4474a4"]])

export default __exports__